import { createContext, useState } from "react";
import { logoutFn } from "./http";
import { getStoredItem } from "./lib";

export const AuthContext = createContext({
  isAuthenticated: false,
  isUser: false,
  login: (token) => {},
  logout: () => {},
  user: "",
  setUser: (user) => {},
  token: "",
  mode: false,
});

export default function AuthProvider({ children }) {
  const initialUser = getStoredItem("user") || "";
  const initialToken = getStoredItem("token");
  const initialMode = getStoredItem("mode");

  const [token, setToken] = useState(initialToken);
  const [userDetail, setUserDetail] = useState(initialUser);

  const isAuthenticated = !!token;
  const isUser = !!userDetail;

  function login(token) {
    setToken(token);
  }

  async function logout() {
    setToken(null);
    setUserDetail(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    try {
      await logoutFn;
    } catch (error) {
      console.log(error);
    }
  }

  function setUser(user) {
    setUserDetail(user);
  }

  const value = {
    token,
    login,
    logout,
    user: userDetail,
    isAuthenticated,
    setUser,
    isUser,
    mode: initialMode,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
